import React from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils/currency';

import styles from './Summary.module.css';

const Summary = ({
  firstName,
  lastName,
  shippingAddress,
  orderId,
  orderTotal,
  orderDate,
}) => {
  const date = moment(orderDate).format('MMMM DD, YYYY');

  return (
    <div className={styles.container}>
      <div className={styles.shippingAddress}>
        <div className={styles.fieldName}>SHIPPING TO</div>
        <p className={styles.fieldValue}>{`${firstName} ${lastName}`}</p>
        <p className={styles.fieldValue}>{shippingAddress.address1}</p>
        {shippingAddress.address2 && (
          <p className={styles.fieldValue}>{shippingAddress.address2}</p>
        )}
        <p
          className={styles.fieldValue}
        >{`${shippingAddress.city}, ${shippingAddress.region} ${shippingAddress.code}`}</p>
      </div>
      <div className={styles.boxContainer}>
        <div className={styles.box}>
          <div className={styles.fieldName}>DATE</div>
          <p className={styles.fieldValue}>{date}</p>
        </div>
        <div className={styles.box}>
          <div className={styles.fieldName}>PAYMENT METHOD</div>
          <p className={styles.fieldValue}>Card on file</p>
        </div>
        <div className={styles.box}>
          <div className={styles.fieldName}>INVOICE</div>
          <p className={styles.fieldValue}>{orderId}</p>
        </div>
        <div className={styles.box}>
          <div className={styles.fieldName}>TOTAL</div>
          <p className={styles.fieldValue} id="order-summary-total">
            {formatCurrency(orderTotal / 100)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;
